// Temporary compatibility shim - wraps usePlayerAuth to provide old interface
// This allows gradual migration of remaining files
import { usePlayerAuth } from './usePlayerAuth';

export interface Player {
  id: string;
  user_id: string;
  player_group_id: string;
  display_name: string;
  is_active: boolean;
  is_default: boolean;
  created_at: string;
  updated_at: string;
}

export const useCurrentPlayer = () => {
  const { playerSession, loading } = usePlayerAuth();
  
  // Convert playerSession to old Player interface
  const currentPlayer: Player | null = playerSession ? {
    id: playerSession.playerId,
    user_id: playerSession.playerId, // Using playerId as fallback
    player_group_id: playerSession.groupId,
    display_name: playerSession.playerName,
    is_active: true,
    is_default: false,
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  } : null;

  return {
    currentPlayer,
    playerId: playerSession?.playerId || null,
    loading,
    error: null
  };
};
